export default {
  title: 'Dictionaries',

  states: {
    loading: 'Loaded {count}.',
    processing: 'Processing...',
    import: 'Imported {count} rows.',
    done: 'Imported {count} rows.'
  },

  dialogs: {
    create: 'Create new key',

    titles: {
      remove: 'Confirm dictionary deletion'
    }
  },

  new: {
    key: 'New key'
  },

  titles: {
    'phone:mnp': 'MNP',
    'phone:ranges': 'Prefixes',
    'phone:opgroups': 'Operator groups',
    upload: 'Upload',
    import: 'Import',
    mix: 'Merge prefixes from the partner server?',
    createGroup: 'Create operator group',
    group: 'Group',
    operator: 'Operator',
    number: 'Number',
    mcc: 'MCC',
    mnc: 'MNC',

    service: {
      mnp: 'MNP',
      ranges: 'Ranges',
      operatorGroups: 'Operator groups'
    }
  },

  labels: {
    key: 'Key',
    opcode: 'Operator code',
    group: 'Group',
    groupName: 'Group name',
    operatorName: 'Operator name',
    operator: 'Operator',
    number: 'Number',
    region: 'Region',
    prefix: 'Prefix',
    mcc: 'MCC',
    mnc: 'MNC',
    type: 'Dictionary type',
    regionCode: 'Region code',
    regionName: 'Region name',
    countryCode: 'Country code',
    countryName: 'Country name',
    timeZone: 'Time zone',
    status: 'Status',
    OwnerId: 'Owner',
    total: 'Total: {total}',

    ranges: {
      start: 'Range start',
      end: 'Range end'
    },

    choose: {
      dictionary: 'Choose dictionary',
      key: 'Enter key'
    },

    search: {
      keys: 'Search by keys'
    }
  },

  hints: {
    noItems: 'No dictionaries to show',
    loading: 'Do not close or reload window while processing import.',
    importOr: 'Or choose a file in the file manager',

    empty: {
      default: 'Search results will appear here',
      search: 'No data found for this number'
    }
  },

  buttons: {
    compile: 'Compile',
    set: 'Activate',
    unset: 'Deactivate',

    add: {
      range: 'Add range'
    }
  },

  contents: {
    confirm: {
      remove: {
        dictionary: 'Are you sure you want to delete dictionary {title}?',
        key: 'Are you sure you want to delete key {title}?'
      }
    }
  },

  snackbars: {
    updated: 'Dictionary successfully updated.',

    dictionary: {
      created: 'Dictionary successfully created.',
      compile: 'Dictionary compiled successfully.',
      updated: 'Dictionary successfully updated.',
      removed: 'Dictionary successfully removed.'
    },
    key: {
      created: 'Key in dictionary successfully created.',
      updated: 'Key in dictionary successfully updated.',
      removed: 'Key in dictionary successfully removed.'
    }
  },

  statuses: {
    created: 'Created',
    ready: 'Ready',
    downloading: 'Downloading',
    importing: 'Importing',
    importError: 'Error during import',
    compiling: 'Compiling',
    compiled: 'Compiled',
    compileError: 'Error during compilation',
    activated: 'Activated'
  },

  tooltips: {
    info: 'Details about the CSV file format',

    upload: {
      file: 'Import from file',
      partner: 'Import from the partner server'
    }
  },

  filters: {
    items: {
      default: 'System dictionaries'
    }
  },

  info: {
    hint: 'Column names are case sensitive',

    rows: {
      Number: 'phone number',
      OwnerId: 'operator name',
      MCC: 'MCC',
      MNC: 'MNC',
      NumberFrom: 'phone number where the range starts',
      NumberTo: 'phone number that ends the range',
      RegionCode: 'region code',
      GROUP: 'group name',
      OrgCode: 'operator name',
      TYPE: 'phone number type (city ABC, mobile DEF)'
    }
  }
}
